import { useContext, useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type DeclienConnfirmDialogProps = {
  open: boolean;
  onOk: (declineKbn: string) => void;
  onClose: () => void;
  examination_no: number;
  result: string;
};

export const DeclineConfirmDialog = ({
  open,
  onOk,
  onClose,
  examination_no,
  result,
}: DeclienConnfirmDialogProps) => {
  const { t: tMessage } = useTranslationWithLang('message');
  const { t: tAuditionInfo } = useTranslationWithLang('auditionInfo');

  const declineKbn = examination_no === 1 || (examination_no >= 2 && result === '2') ? '5' : '1';

  return (
    <Dialog open={open} disablePortal sx={{ zIndex: 5 }}>
      <DialogContent dividers>
        <Typography className="whitespace-pre-wrap">
          {declineKbn === '5' ? tMessage('MU005F0208W') : tMessage('MU005F0207W')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          style={{ color: 'var(--c-textinput-label)' }}
          title={tAuditionInfo('TU005_018')}
        >
          {tAuditionInfo('TU005_018')}
        </Button>
        <Button
          onClick={() => onOk(declineKbn)}
          autoFocus
          style={{ color: 'var(--c-error)' }}
          title={tAuditionInfo('TU005_055')}
        >
          {tAuditionInfo('TU005_055')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
